import React from 'react';

const IcArrowFillRoundUpBlue = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_2551_21676)'>
                <circle cx='12' cy='12' r='12' fill='#F0F6FF' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16.8951 13.695C17.1684 13.4216 17.1684 12.9784 16.8951 12.705L12.4951 8.30502C12.2217 8.03165 11.7785 8.03165 11.5051 8.30502L7.10512 12.705C6.83176 12.9784 6.83176 13.4216 7.10512 13.695C7.37849 13.9683 7.8217 13.9683 8.09507 13.695L12.0001 9.78994L15.9051 13.695C16.1785 13.9683 16.6217 13.9683 16.8951 13.695Z'
                    fill='#264C97'
                />
            </g>
            <defs>
                <clipPath id='clip0_2551_21676'>
                    <rect width='24' height='24' rx='12' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IcArrowFillRoundUpBlue;
